import { http } from '../index'

// 学员线索相关接口类型定义
export interface StudentLead {
  id: number
  lead_no: string
  name: string
  phone?: string
  wechat?: string
  gender: number
  gender_text: string
  id_card?: string
  store_id?: number
  sales_admin_id?: number
  service_admin_id?: number
  source?: string
  intended_course?: string
  purpose: number
  purpose_text: string
  address?: string
  has_certificate: number
  has_certificate_text: string
  remark?: string
  internal_remark?: string
  status: number
  status_text: string
  priority: number
  priority_text: string
  expected_amount?: number
  last_follow_at?: string
  next_follow_at?: string
  follow_count: number
  store?: {
    id: number
    name: string
  }
  sales_admin?: {
    id: number
    name: string
  }
  service_admin?: {
    id: number
    name: string
  }
  created_at: string
  updated_at: string
}

export interface StudentLeadListParams {
  page?: number
  per_page?: number
  keyword?: string
  store_id?: number
  sales_admin_id?: number
  service_admin_id?: number
  status?: number
  priority?: number
  gender?: number
  purpose?: number
  has_certificate?: number
  source?: string
  intended_course?: string
  expected_amount_min?: number
  expected_amount_max?: number
  next_follow_start?: string
  next_follow_end?: string
  created_start_date?: string
  created_end_date?: string
  sort_field?: string
  sort_order?: string
}

export interface StudentLeadCreateData {
  name: string
  phone?: string
  wechat?: string
  gender: number
  id_card?: string
  store_id?: number
  sales_admin_id?: number
  service_admin_id?: number
  source?: string
  intended_course?: string
  purpose: number
  address?: string
  has_certificate: number
  remark?: string
  internal_remark?: string
  status?: number
  priority?: number
  expected_amount?: number
  next_follow_at?: string
}

export interface StudentLeadUpdateData extends Partial<StudentLeadCreateData> {}

export interface StudentLeadBatchData {
  ids: number[]
  operation: 'delete' | 'update_status' | 'update_priority' | 'assign_sales' | 'assign_service'
  status?: number
  priority?: number
  sales_admin_id?: number
  service_admin_id?: number
}

export interface StudentLeadConvertData {
  enrollment_date?: string
  graduation_date?: string
  remark?: string
  internal_remark?: string
}

export interface StudentLeadStatistics {
  total: number
  new: number
  following: number
  interested: number
  converted: number
  invalid: number
  high_priority: number
  medium_priority: number
  low_priority: number
  conversion_rate: number
  today_new: number
  overdue: number
}

// 学员线索API
export const studentLeadApi = {
  // 获取线索列表
  list: (params: StudentLeadListParams = {}) => {
    return http.get('/admin/student-leads', { params })
  },

  // 获取待跟进线索列表
  needFollow: (params: StudentLeadListParams = {}) => {
    return http.get('/admin/student-leads/need-follow', { params })
  },

  // 创建线索
  create: (data: StudentLeadCreateData) => {
    return http.post('/admin/student-leads', data)
  },

  // 获取线索详情
  detail: (id: number) => {
    return http.get(`/admin/student-leads/${id}`)
  },

  // 更新线索
  update: (id: number, data: StudentLeadUpdateData) => {
    return http.put(`/admin/student-leads/${id}`, data)
  },

  // 删除线索
  delete: (id: number) => {
    return http.delete(`/admin/student-leads/${id}`)
  },

  // 更新线索状态
  updateStatus: (id: number, status: number, remark?: string) => {
    return http.patch(`/admin/student-leads/${id}/status`, { status, remark })
  },

  // 转化为学员
  convert: (id: number, data: StudentLeadConvertData = {}) => {
    return http.post(`/admin/student-leads/${id}/convert`, data)
  },

  // 批量操作
  batch: (data: StudentLeadBatchData) => {
    return http.post('/admin/student-leads/batch', data)
  },

  // 获取统计数据
  statistics: (params: StudentLeadListParams = {}) => {
    return http.get('/admin/student-leads/statistics/overview', { params })
  },

  // 获取转化率统计
  conversion: (params: StudentLeadListParams = {}) => {
    return http.get('/admin/student-leads/statistics/conversion', { params })
  },

  // 获取分布统计
  distribution: (params: StudentLeadListParams = {}) => {
    return http.get('/admin/student-leads/statistics/distribution', { params })
  },

  // 获取今日新增线索
  todayNew: () => {
    return http.get('/admin/student-leads/today-new')
  },

  // 获取超期线索
  overdue: () => {
    return http.get('/admin/student-leads/overdue')
  },

  // 导出数据
  export: (params: StudentLeadListParams = {}) => {
    return http.post('/admin/student-leads/data/export', params)
  },
}
